export * from './array';
export * from './compare';
export * from './rxjs';
export * from './time';

export function clamp(a: number, min: number, max: number) {
    return Math.max(Math.min(a, max), min);
}
